import { startAuthentication, startRegistration } from '@simplewebauthn/browser';
import type {
  PublicKeyCredentialRequestOptionsJSON,
  PublicKeyCredentialCreationOptionsJSON,
} from '@simplewebauthn/types';
import { api } from '../api-client';

export async function registerPasskey(displayName: string, deviceName: string) {
  const { options, user } = await api<{
    options: PublicKeyCredentialCreationOptionsJSON;
    user: { id: string; name: string };
  }>('/api/auth/register-challenge', {
    method: 'POST',
    body: JSON.stringify({ displayName, deviceName }),
  });
  const response = await startRegistration({ optionsJSON: options });
  await api('/api/auth/register-verify', {
    method: 'POST',
    body: JSON.stringify({ userId: user.id, response }),
  });
  return user;
}

export async function loginWithPasskey() {
  const { options } = await api<{
    options: PublicKeyCredentialRequestOptionsJSON;
  }>('/api/auth/login-challenge', { method: 'POST' });
  const response = await startAuthentication({ optionsJSON: options });
  await api('/api/auth/login-verify', {
    method: 'POST',
    body: JSON.stringify({ response }),
  });
}
